import { render, staticRenderFns } from "./music_library.vue?vue&type=template&id=e6bdafb4"
import script from "./music_library.vue?vue&type=script&lang=js"
export * from "./music_library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports